import './OverrideModal.scss';
import React, { Component, type ReactNode } from 'react';
import CloseButton from '../../closeButton/CloseButton';

type OverrideModalProps = {
    show: boolean;
    onClose: () => void;
    children: ReactNode[];
};

class OverrideModal extends Component<OverrideModalProps> {
    render() {
        // Render nothing if the "show" prop is false
        if (!this.props.show) {
            return null;
        }
        return (
            <div className="b-override-modal">
                <div className="b-modal-window">
                    <CloseButton
                        className="b-override-modal__close-button"
                        large
                        onClick={this.props.onClose}
                    />
                    <div className="b-override-modal__content">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

export default OverrideModal;
